<template>
  <div class="app-content-home">
    <div class="app-content-home__about">
      <div class="app-content-home__about-content">
        <h1 class="app-content-home__about-content__title">About us</h1>
        <div class="app-content-home__about-content__text">
          We are a midwest family-owned business that cares about the customer’s needs. We are open
          to build food trucks and trailers to meet your business needs.
        </div>
      </div>
    </div>

    <div class="app-content-home__services">
      <div class="app-content-home__services-left">
        <h1 class="app-content-home__services-left__title">
          List
          <br />of services
        </h1>
        <div class="app-content-home__services-left__text">
          We offer an option of trucks or trailers that can be custom designed by your business
          needs. We also offer an upgrade or repair option, if you need something done inside the
          vehicle.
        </div>
      </div>

      <div class="app-content-home__services-right">
        <div class="app-content-home__services-right__item">
          <!--v-icon class="app-content-home__services-right__item-icon">mdi-caravan</v-icon-->
          <img
            src="/img/icons_c/trailer-with-hitch3.png"
            class="app-content-home__services-right__item-img"
          />
          <h3 class="app-content-home__services-right__item-title">
            Food Trailer
          </h3>
        </div>
        <div class="app-content-home__services-right__item">
          <!--v-icon class="app-content-home__services-right__item-icon">mdi-bus-school</v-icon-->
          <img
            src="/img/icons_c/truck_icon2.png"
            class="app-content-home__services-right__item-img"
          />
          <h3 class="app-content-home__services-right__item-title">
            Food Truck
          </h3>
        </div>
        <div class="app-content-home__services-right__item">
          <!--v-icon class="app-content-home__services-right__item-icon">mdi-face-agent</v-icon-->
          <img
            src="/img/icons_c/services_icon3.png"
            class="app-content-home__services-right__item-img"
          />
          <h3 class="app-content-home__services-right__item-title">Service</h3>
        </div>
      </div>
    </div>

    <contact-us></contact-us>
  </div>
</template>

<script>
import ContactUs from '@/components/ContactUs'

export default {
  name: 'home',
  components: {
    ContactUs
  },
  data: () => ({})
}
</script>
